import { useMemo } from "react";
import { createPath, useLocation, useSearchParams } from "react-router";
import { useHash } from "react-use";
import { getSettings } from "src/settings";

export const NEXT_URL_IDENTIFIER = "nextUrl";

function isValidPath(redirectPath: string): boolean {
	return (
		(!redirectPath.includes("/?state=") &&
			redirectPath.startsWith(getSettings().oidc.redirectUri)) ||
		redirectPath === "/"
	);
}

export function getNextUrl(): string {
	const { href } = window.location;
	return isValidPath(href) ? href : "/";
}

export function createNextUrlParam(): string {
	const searchParams = new URLSearchParams();
	searchParams.append(NEXT_URL_IDENTIFIER, getNextUrl());
	return searchParams.toString();
}

export function useGetNextUrlParam(): string {
	const [searchParams] = useSearchParams();
	const [hash] = useHash();
	if (!searchParams.has(NEXT_URL_IDENTIFIER)) {
		return `/${hash}`;
	}

	return `${searchParams.get(NEXT_URL_IDENTIFIER)}${hash}`;
}

export function useSetNextUrlParam() {
	const location = useLocation();

	return useMemo(() => {
		const searchParams = new URLSearchParams();

		const nextUrl = createPath(location);

		searchParams.append(NEXT_URL_IDENTIFIER, nextUrl);

		return {
			searchParams,
			searchString: `${NEXT_URL_IDENTIFIER}=${nextUrl}`,
		};
	}, [location]);
}
